import { KONTAKT_LABEL_COLORS, ALL_KONTAKT_LABELS, type KontaktLabel } from '@/lib/kontakt-labels';

interface LabelPickerProps {
  selectedLabels: KontaktLabel[];
  onChange: (labels: KontaktLabel[]) => void;
}

export default function LabelPicker({ selectedLabels, onChange }: LabelPickerProps) {
  const toggle = (label: KontaktLabel) => {
    if (selectedLabels.includes(label)) {
      onChange(selectedLabels.filter((l) => l !== label));
    } else {
      onChange([...selectedLabels, label]);
    }
  };

  return (
    <div data-testid="label-picker" className="flex flex-wrap gap-1.5">
      {ALL_KONTAKT_LABELS.map((label) => {
        const cfg = KONTAKT_LABEL_COLORS[label];
        const active = selectedLabels.includes(label);
        return (
          <button
            key={label}
            type="button"
            onClick={() => toggle(label)}
            className="px-2.5 py-1 rounded-lg text-[11px] font-medium transition-all border"
            style={
              active
                ? { backgroundColor: cfg.bg, color: cfg.text, borderColor: cfg.text + '40' }
                : { backgroundColor: 'transparent', color: '#6B7280', borderColor: '#E5E7EB' }
            }
          >
            {cfg.label}
          </button>
        );
      })}
    </div>
  );
}
